var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'pc-bg-color': _vm.checkPcBgColorClass() },attrs:{"id":"app"}},[(_vm.isDocpleNative())?_c('AppDeprecationNotice'):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }